import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form } from 'semantic-ui-react'
import { handleErrors, parseDate } from '~/utils/helpers'
import { FormProvider, useForm } from 'react-hook-form'
import { FarmerCreateOptionsType, FarmersService } from '~/api/services/farmers'
import FirstRow from './Rows/FirstRow'
import SecondRow from './Rows/SecondRow'
import ThirdRow from './Rows/ThirdRow'
import FourthRow from './Rows/FourthRow'
import Layout from '~/components/Layout'
import { useAuth } from '~/routes/components/AuthProvider'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import { El } from '~/components/Layout/style'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import notify from '~/components/Notify'
import { Farmer } from '~/api/services/individualFilters'

interface Props {
  farmerOptions: FarmerCreateOptionsType
}

const FarmerDetails: React.FC<Props> = ({ farmerOptions }) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { systemData: { logged: { roleSlug } } } = useAuth()

  const lightUserLogged = roleSlug === LIGHT_USER_ROLE_SLUG

  const [isBusy, setIsBusy] = useState(false)
  const [farmersList, setFarmersList] = useState<Farmer[]>([])

  const methods = useForm({
    mode: 'onChange'
  })

  useEffect(() => {
    fetchDetails()
  }, [])

  async function fetchDetails() {
    setIsBusy(true)
    try {
      const response = await FarmersService.getFarmerDetails(id)
      const farmersResponse = await FarmersService.getFarmers({ isMain: 1, page: 0, search: '' })
      if (!response.data.farmer.districtId && response.data.farmer.zip) {
        const zipData = await FarmersService.getZipDistrictState({ zip: response.data.farmer.zip })
        response.data.farmer.districtId = zipData.data.id
      }
      setFarmersList(farmersResponse.data)
      methods.reset({
        ...response.data.farmer,
        farmerType: response.data.farmer.parentId ? 'sub' : 'main',

        terminationDate: response.data.farmer?.terminationDate ?
          dayjs(response.data.farmer?.terminationDate).format('DD.MM.YYYY') :
          response.data.farmer?.terminationDate,

        lastDeliveryDate: response.data.farmer?.lastDeliveryDate ?
          dayjs(response.data.farmer?.lastDeliveryDate).format('DD.MM.YYYY') :
          response.data.farmer?.lastDeliveryDate
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderForm() {
    return <>
      <Form.Group widths={'equal'}>
        <FirstRow
          farmerOptions={farmerOptions}
          farmersList={farmersList}
        />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <SecondRow />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <ThirdRow farmersOptions={farmerOptions} />
      </Form.Group>
      <>
        <FourthRow farmersOptions={farmerOptions} />
      </>
    </>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (!id && data?.farmerType === 'sub') {
        delete data.farmerGroupId
      }
      data.terminationDate = data?.terminationDate ? parseDate(data.terminationDate) : data?.terminationDate
      data.lastDeliveryDate = data?.lastDeliveryDate ? parseDate(data.lastDeliveryDate) : data?.lastDeliveryDate
      await FarmersService.updateFarmerDetails(id, data)
      notify(t('Successfully update farmer details'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton
        loading={isBusy}
      >{t('Update')}</El.PageHeaderActionButton>
    </>
  }

  return <Layout
    childContainerSize={'auto'}
    isBusy={isBusy}
    useSpinner
    onSubmit={methods.handleSubmit(onSubmit)}
    actions={!lightUserLogged && renderActions()}
  >
    <FormProvider {...methods}>
      {renderForm()}
    </FormProvider>
    {/*  {coordinates && <GoogleMap
      zoomLevel={20}
      lat={coordinates.lat}
      lng={coordinates.lng}
    />} */}
  </Layout>
}
export default FarmerDetails
